module.exports = __webpack_public_path__ + "img/dangweijuwei_icon.6916cf83.png";